import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  StyledPageHeading,
  StyledPageTitle,
  StyledPageSubTitle,
} from './PageHeading.styles';

export interface PageHeadingProps {
  /** the main title */
  title: string | JSX.Element;
  /** an optional subtitle */
  subtitle?: string | JSX.Element;
  /** whether or not the title is loading */
  loading?: boolean;
}

/**
Top-level stylzed h1 for use at the top of pages
*/
export const PageHeading: FC<PageHeadingProps> = ({
  title,
  subtitle,
  loading,
}) => {
  return (
    <StyledPageHeading>
      {subtitle && (
        <StyledPageSubTitle data-testid="subtitle">
          {subtitle}
        </StyledPageSubTitle>
      )}
      <StyledPageTitle data-testid="title">
        <span aria-hidden={true}>/</span>
        {loading ? (
          <Skeleton
            style={{
              display: 'inline-block',
              width: '40rem',
              maxWidth: '100%',
              height: '0.8em',
            }}
          />
        ) : (
          title
        )}
      </StyledPageTitle>
    </StyledPageHeading>
  );
};

export default PageHeading;
